<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ba1mGM/tc-custom/9781480400658.jpg?1733124417901" alt="This image is the cover for the book Alice Factor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alice Factor
      </h1>
      <p class="bookDescription body article font2">
        <b>As war looms over Europe, a diamond dealer fights the Nazis from behind enemy lines<br/></b><br/>It is 1937, and the Antwerp Diamond Exchange is preparing for war. The Wehrmacht is hungry for industrial diamonds, without which it’s impossible to manufacture armor, radios, or guns. For Richard Hagen, a rare gentile jewelry dealer, business has never been better. But this quiet diamond expert is about to begin a war of his own.<br/><br/>On a business trip to Germany, Hagen attempts to sabotage Nazi efforts to secure the diamonds they need so desperately. Masquerading as a friend of the Reich, he sends home messages in a code based on <i>Alice in Wonderland</i>. The Antwerp Exchange is preparing to flee to London, but Hagen will remain in mainland Europe. As the Gestapo closes in, he will have to stay diamond-sharp to survive.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. Robert Janes
      </h2>
      
      <p class="authorDescription body article">J. Robert Janes (b. 1935) is a mystery author best known for writing historical thrillers. Born in Toronto, he holds degrees in mining and geology, and worked as an engineer, university professor, and textbook author started he began writing fiction. He began his career as a novelist by writing young adult books, starting with <i>The Odd-Lot Boys and the Tree-Fort War</i> (1976). He wrote his last young adult novel, <i>Murder in the Market</i>, in 1985, by which time he had begun writing for adults, starting with the four-novel Richard Hagen series.<BR><BR>In 1992, Janes published <i>Mayhem</i>, the first in the long-running St-Cyr and Kohler series, for which he is best known. These police procedurals set in Nazi-occupied France have been praised for the author&rsquo;s attention to historical detail, as well as their swift-moving plots. The thirteenth in the series, <i>Bellringer</i>, was published in 2012.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71c4c829